import { render, staticRenderFns } from "./ApprovedTable.vue?vue&type=template&id=0855952f"
import script from "./ApprovedTable.vue?vue&type=script&lang=js"
export * from "./ApprovedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports